"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireDefault(require("react"));

var _propTypes = babelHelpers.interopRequireDefault(require("prop-types"));

// @babel: { "presets": [ "es2015", "react" ], "plugins": [ "transform-flow-strip-types", "transform-decorators-legacy", "transform-class-properties", "transform-object-rest-spread" ]}
// react-redux does a bunch of stuff with pure components / checking if it needs to re-render.
// not sure if we need to do the same.
var inject = function inject(WrappedComponent) {
  var _class, _temp;

  var componentOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _componentOptions$wit = componentOptions.withRef,
      withRef = _componentOptions$wit === void 0 ? false : _componentOptions$wit;
  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    babelHelpers.inherits(_class, _React$Component);

    function _class(props, context) {
      var _this;

      babelHelpers.classCallCheck(this, _class);

      if (!context || !context.getRegisteredElements) {
        throw new Error("It looks like you are trying to inject Stripe context outside of an Elements context.\nPlease be sure the component that calls createSource or createToken is within an <Elements> component.");
      }

      _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_class).call(this, props, context));

      _this.requireElement = function (specifiedType) {
        var element = _this.findElement(specifiedType);

        if (element) {
          return element;
        } else {
          throw new Error("You did not specify the type of Source or Token to create.\n        We could not infer which Element you want to use for this operation.");
        }
      };

      _this.findElement = function (specifiedType) {
        var allElements = _this.context.getRegisteredElements();

        var matchingElements = specifiedType === 'auto' ? allElements : allElements.filter(function (_ref) {
          var type = _ref.type;
          return type === specifiedType;
        });

        if (matchingElements.length === 1) {
          return matchingElements[0].element;
        } else if (matchingElements.length > 1) {
          throw new Error("You did not specify the type of Source or Token to create.\n        We could not infer which Element you want to use for this operation.");
        } else {
          return null;
        }
      };

      _this.wrappedCreateToken = function () {
        var typeOrOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (typeOrOptions && babelHelpers.typeof(typeOrOptions) === 'object') {
          var type = typeOrOptions.type,
              rest = babelHelpers.objectWithoutProperties(typeOrOptions, ["type"]);
          var specifiedType = typeof type === 'string' ? type : 'auto';

          var element = _this.requireElement(specifiedType);

          return _this.context.stripe.createToken(element, rest);
        } else if (typeof typeOrOptions === 'string') {
          return _this.context.stripe.createToken(typeOrOptions, options);
        } else {
          throw new Error("Invalid options passed to createToken. Expected an object, got ".concat(babelHelpers.typeof(typeOrOptions), "."));
        }
      };

      _this.wrappedCreateSource = function () {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (options && babelHelpers.typeof(options) === 'object') {
          var type = options.type,
              rest = babelHelpers.objectWithoutProperties(options, ["type"]); // eslint-disable-line no-unused-vars

          var specifiedType = typeof type === 'string' ? type : 'auto';

          var element = _this.findElement(specifiedType);

          if (element) {
            return _this.context.stripe.createSource(element, rest);
          } else if (specifiedType !== 'auto') {
            return _this.context.stripe.createSource(options);
          } else {
            throw new Error("You did not specify the type of Source to create.\n          We also could not find any Elements in the current context.");
          }
        } else {
          throw new Error("Invalid options passed to createSource. Expected an object, got ".concat(babelHelpers.typeof(options), "."));
        }
      };

      return _this;
    }

    babelHelpers.createClass(_class, [{
      key: "getWrappedInstance",
      value: function getWrappedInstance() {
        if (!withRef) {
          throw new Error('To access the wrapped instance, the `{withRef: true}` option must be set when calling `injectStripe()`');
        }

        return this.wrappedInstance;
      }
    }, {
      key: "stripeProps",
      value: function stripeProps() {
        return babelHelpers.objectSpread({}, this.context.stripe, {
          // These are the only functions that take elements.
          createToken: this.wrappedCreateToken,
          createSource: this.wrappedCreateSource
        });
      } // Require that exactly one Element is found.

    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        return _react.default.createElement(WrappedComponent, babelHelpers.extends({}, this.props, {
          stripe: this.stripeProps(),
          ref: withRef ? function (c) {
            _this2.wrappedInstance = c;
          } : null
        }));
      }
    }]);
    return _class;
  }(_react.default.Component), _class.contextTypes = {
    stripe: _propTypes.default.object.isRequired,
    getRegisteredElements: _propTypes.default.func
  }, _class.displayName = "InjectStripe(".concat(WrappedComponent.displayName || WrappedComponent.name || 'Component', ")"), _temp;
};

var _default = inject;
exports.default = _default;